import React from "react"
import { Container, Headline, Body } from "./styles/grid"
import { Container as MainContainer } from "../../containers"

export default function Grid({ title, children, ...rest }) {
  return (
    <Container {...rest}>
      <MainContainer>
        <Headline>{title}</Headline>
        {children}
      </MainContainer>
    </Container>
  )
}

Grid.Body = function GridBody({ children, ...rest }) {
  return <Body>{children}</Body>
}
